/**
 * ryz_last_seen – variant IDs of the last 6 viewed products (newest first), PDP only.
 * Cookie: comma-separated variant IDs. localStorage map holds [productId, variantId] pairs for per-product dedupe.
 * Requires essential-functions.js (setCookie, getCookie, eraseCookie, checkConsentForService).
 * Only active with consent for the Usercentrics service below.
 */
(function () {
  if (window.ryzLastSeenInit) return;
  window.ryzLastSeenInit = true;

  const SERVICE_NAME = 'Shopify Analytics';
  const COOKIE_NAME = 'ryz_last_seen';
  const STORAGE_KEY = 'ryz_last_seen_map';
  const MAX_ITEMS = 6;
  const LIFETIME_HOURS = 14 * 24;

  const section = document.querySelector('.product-container[data-productid]');
  const productId = section?.dataset.productid;
  if (!productId) return;

  let hasConsent = checkConsentForService(SERVICE_NAME) === true;

  function readMap() {
    try {
      const map = JSON.parse(localStorage.getItem(STORAGE_KEY));
      if (Array.isArray(map)) return map;
    } catch (e) {}
    // Map missing: rebuild from cookie without product info (entries age out)
    const raw = getCookie(COOKIE_NAME);
    return raw ? decodeURIComponent(raw).split(',').filter(Boolean).map((variantId) => [null, variantId]) : [];
  }

  function clear() {
    eraseCookie(COOKIE_NAME);
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  function track(variantId) {
    if (!hasConsent || !variantId) return;
    const map = readMap().filter(([pid, vid]) => pid !== productId && vid !== String(variantId));
    map.unshift([productId, String(variantId)]);
    map.length = Math.min(map.length, MAX_ITEMS);
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(map)); } catch (e) {}
    setCookie(COOKIE_NAME, map.map((entry) => entry[1]).join(','), LIFETIME_HOURS);
  }

  const getCurrentVariantId = () => section.querySelector('input[name="id"]')?.value;

  // Variant switch: variant-selects dispatches 'change' on the hidden form input
  section.addEventListener('change', (e) => {
    if (e.target.matches('input[name="id"]')) track(e.target.value);
  });

  window.addEventListener('ucEvent', (e) => {
    if (e.detail?.event !== 'consent_status') return;
    const granted = typeof e.detail[SERVICE_NAME] === 'boolean' ? e.detail[SERVICE_NAME] : checkConsentForService(SERVICE_NAME) === true;
    if (granted === hasConsent) return;
    hasConsent = granted;
    if (hasConsent) track(getCurrentVariantId());
    else clear();
  });

  track(getCurrentVariantId());
})();
